#import "../fragments/inbox-sidebar-thread-fragment.graphql"

query GetInboxThreadsByIds($ids: [ID!]!, $botStatus: ThreadBotStatus!) {
    inboxThreads(ids: $ids, botStatus: $botStatus) {
        ...InboxSidebarThreadFragment
    }
}
